import React from 'react';
import { LocationNameHeading } from './styles';
import { string, func } from 'prop-types';

function LocationName({ locationUrl, onLocationClick, children }) {
  return (
    <LocationNameHeading>
      <a
        data-testid={`MapCardLocationName`}
        href={locationUrl}
        onClick={onLocationClick}
      >
        {children}
      </a>
    </LocationNameHeading>
  );
}

LocationName.propTypes = {
  locationUrl: string.isRequired,
  onLocationClick: func.isRequired,
  children: string.isRequired
};

export default LocationName;
